import axios from 'axios';

const { REACT_APP_BASE_URL } = process.env

const getToken = () => {
    return localStorage.getItem('token')
}

async function getAttachmentOfFeature(layerId: any, featureId: any) {
    return axios.get(REACT_APP_BASE_URL + `rest/v1/attachment/${layerId}/${featureId}`, { params: { token: getToken() } });
}
async function deleteFileById(attachmentId: any) {
    return axios.delete(REACT_APP_BASE_URL + `rest/v1/attachment/${attachmentId}`, { params: { token: getToken() } });
}
async function addAttachment(layerId: any, featureId: any, file: any) {
    return axios.post(REACT_APP_BASE_URL + `rest/v1/attachment/${layerId}/${featureId}`, file, { params: { token: getToken() } });
}
async function getAttachmentsOfLayer(layerId: any) {
    return axios.get(REACT_APP_BASE_URL + `rest/v1/attachment/exportRelation/${layerId}`, { params: { token: getToken() } });
}
async function getAttachmentListByLayerId(layerId: any) {
    return axios.get(REACT_APP_BASE_URL + `rest/v1/attachment/byLayerId/${layerId}`, { params: { token: getToken() } });
}

export const AttachmentRestApi = {
    getAttachmentOfFeature,
    deleteFileById,
    addAttachment,
    getAttachmentsOfLayer,
    getAttachmentListByLayerId
}